<template>
  <div class="person-coupon-container">
    <div class="title">我的收藏</div>
    <goods-item ></goods-item>
  </div>
</template>
  <script>
  import goodsItem from './goods-item-ceil.vue';
    export default {
      components:{goodsItem},
      data() {
        return{
          
        }
      },
      methods:{
        goto(){
          this.$router.push({path:'/person/servicedetail'})
        },
      },

      
    }
  </script>

  <style lang="scss" scoped>
    .person-coupon-container{
      position: relative;
      background: #ffffff;
      padding: 38px 46px;
      min-height: 1000px;
      .title{
        font-size: 22px;
        color: #333333;
        font-weight: 600;
        margin-bottom: 24px;
      }

    }
  </style>


// WEBPACK FOOTER //
// src/pages/person/components/person-collect/index.vue